import THERMOSTAT_OFF_RECEIVER_OFF from './thermostat_off_receiver_off';

const THERMOSTAT_ON_RECEIVER_OFF = [
  ...THERMOSTAT_OFF_RECEIVER_OFF,
];

export default THERMOSTAT_ON_RECEIVER_OFF;
